export enum LOADING_RENEWAL_QUOTATION_STATES {
    INIT_LOADING_RENEWAL = "INIT_LOADING_RENEWAL",
    STEP_ONE_SERVICES_LOADING_RENEWAL = "STEP_ONE_SERVICES_LOADING_RENEWAL",
    STEP_ONE_SERVICES_LOADED_RENEWAL = "STEP_ONE_SERVICES_LOADED_RENEWAL",
    STEP_ONE_DATA_FILLING_RENEWAL = "STEP_ONE_DATA_FILLING_RENEWAL",
    STEP_ONE_DATA_FILLED_RENEWAL = "STEP_ONE_DATA_FILLED_RENEWAL",
    STEP_TWO_SERVICES_LOADING_RENEWAL = "STEP_TWO_SERVICES_LOADING_RENEWAL",
    STEP_TWO_SERVICES_LOADED_RENEWAL = "STEP_TWO_SERVICES_LOADED_RENEWAL",
    STEP_TWO_DATA_FILLING_RENEWAL = "STEP_TWO_DATA_FILLING_RENEWAL",
    STEP_TWO_DATA_FILLED_RENEWAL = "STEP_TWO_DATA_FILLED_RENEWAL",
    STEP_THREE_SERVICES_LOADING_RENEWAL = "STEP_THREE_SERVICES_LOADING_RENEWAL",
    STEP_THREE_SERVICES_LOADED_RENEWAL = "STEP_THREE_SERVICES_LOADED_RENEWAL",
    STEP_THREE_DATA_FILLING_RENEWAL = "STEP_THREE_DATA_FILLING_RENEWAL",
    STEP_THREE_DATA_FILLED_RENEWAL = "STEP_THREE_DATA_FILLED_RENEWAL",
    STEP_FOUR_SERVICES_LOADING_RENEWAL = "STEP_FOUR_SERVICES_LOADING_RENEWAL",
    STEP_FOUR_SERVICES_LOADED_RENEWAL = "STEP_FOUR_SERVICES_LOADED_RENEWAL",
    STEP_FOUR_DATA_FILLING_RENEWAL = "STEP_FOUR_DATA_FILLING_RENEWAL",
    STEP_FOUR_DATA_FILLED_RENEWAL = "STEP_FOUR_DATA_FILLED_RENEWAL",
    HAS_ERROR_RENEWAL = "HAS_ERROR_RENEWAL",
    FINISH_LOADING_RENEWAL = "FINISH_LOADING_RENEWAL",
  }
  